 <template>
  <div id="app">
    <router-view/>
  </div>
</template>
<style lang="scss">
    @import "assets/scss/app";
</style>
<script>

  export default{
      name: 'IskoligApp',
      created(){
          if (this.$route.query.knetToken){
              sessionStorage.setItem('knetToken', JSON.stringify(this.$route.query.knetToken))
              this.$router.replace({query:{}})
          }
      }
  }
</script>